import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { colors } from '../styles/colors';
import AddWorldForm from './AddWorldForm';
import WorldModal from './WorldModal';

const WorldsList = () => {
  const [worlds, setWorlds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedWorld, setSelectedWorld] = useState(null);

  const fetchWorlds = async () => {
    try {
      const { data, error } = await supabase
        .from('worlds')
        .select('*')
        .order('id');
      if (error) throw error;
      setWorlds(data);
    } catch (err) {
      console.error(err);
      setWorlds([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorlds();

    if (!supabase.channel) return;
    const channel = supabase
      .channel('public:worlds')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'worlds' }, (payload) => {
        if (payload.eventType === 'INSERT') setWorlds((prev) => [...prev, payload.new]);
        if (payload.eventType === 'UPDATE') setWorlds((prev) =>
          prev.map((w) => (w.id === payload.new.id ? payload.new : w))
        );
        if (payload.eventType === 'DELETE') setWorlds((prev) =>
          prev.filter((w) => w.id !== payload.old.id)
        );
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, []);

  return (
    <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', padding: '1rem' }}>
      <div style={{ flex: '2 1 400px', minWidth: '300px' }}>
        <h2 style={{ color: colors.primary }}>Worlds</h2>
        {loading ? (
          <p>Loading...</p>
        ) : worlds.length === 0 ? (
          <p>No worlds found.</p>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: '1rem',
            }}
          >
            {worlds.map((w) => (
              <div
                key={w.id}
                onClick={() => setSelectedWorld(w)}
                style={{
                  backgroundColor: colors.background,
                  padding: '1rem',
                  borderRadius: '12px',
                  border: `1px solid ${colors.primary}20`,
                  boxShadow: '0 8px 18px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 18px rgba(0,0,0,0.08)';
                }}
              >
                <h3 style={{ margin: '0 0 6px 0', color: colors.primary }}>🌍 {w.name}</h3>
                <p style={{ margin: 0, fontWeight: '500', color: colors.textLight }}>
                  Game ID: {w.game_id || 'Unknown'}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ flex: '1 1 300px', minWidth: '280px' }}>
        <AddWorldForm onWorldAdded={(newWorld) => setWorlds((prev) => [...prev, newWorld])} />
      </div>

      <WorldModal world={selectedWorld} onClose={() => setSelectedWorld(null)} />
    </div>
  );
};

export default WorldsList;